import { combineReducers } from 'redux';

import type { Action } from 'Lib/reduxType';

import {
  BIOMETRICS_BLOCKING_CONSENT_INIT,
  BIOMETRICS_IS_COMPLETED_SUCCESS,
  BIOMETRICS_IS_INITIALIZED,
} from 'Store/userBiometrics/constants';
import { UserBiometricsState } from 'Store/userBiometrics/types';

import initialState from './initialState';

type BiometrcisFlow = UserBiometricsState['flow'];
const flowReducer = (state: BiometrcisFlow = initialState.flow, action: Action): BiometrcisFlow => {
  switch (action.type) {
    case BIOMETRICS_BLOCKING_CONSENT_INIT:
      return action.payload?.flow;
    default:
      return state;
  }
};

const isCompletedReducer = (state: boolean = initialState.isCompleted, action: Action): boolean => {
  switch (action.type) {
    case BIOMETRICS_IS_COMPLETED_SUCCESS:
      return true;
    default:
      return state;
  }
};

const isInitializedReducer = (
  state: boolean = initialState.isInitialized,
  action: Action
): boolean => {
  switch (action.type) {
    case BIOMETRICS_IS_INITIALIZED:
      return action.payload?.isInitialized;
    default:
      return state;
  }
};

export const reducer = combineReducers({
  flow: flowReducer,
  isCompleted: isCompletedReducer,
  isInitialized: isInitializedReducer,
});
